import { useTranslation } from 'react-i18next';

import { CallerConnectedStatus } from '@/signalr';
import { TextWithIcon } from '@/ui';

export type CallerChatConnectionStatusComponentProps = {
  status: CallerConnectedStatus;
};

export function CallerChatConnectionStatusComponent({ status }: CallerChatConnectionStatusComponentProps) {
  const { t } = useTranslation();

  return (
    <div className="caller-chat-connection-status">
      {status === CallerConnectedStatus.NotConnectedYet ? (
        <TextWithIcon
          icon="fal fa-message-question"
          cssClass="text-danger"
          text={t('CallerChatConnectionStatusMessage_WaitingForChatOpening')}
        />
      ) : status === CallerConnectedStatus.Connected ? (
        <TextWithIcon
          icon="fal fa-signal-stream"
          cssClass="text-success"
          text={t('CallerChatConnectionStatusMessage_UserConnected')}
        />
      ) : status === CallerConnectedStatus.Disconnected ? (
        <TextWithIcon
          icon="fal fa-message-question"
          cssClass="text-danger"
          text={t('CallerChatConnectionStatusMessage_UserDisconnected')}
        />
      ) : null}
    </div>
  );
}
